import Auth from './Auth'
import router from '../routes'
import MIA from './Backend.MIA'
import store from '../store';

let BASE_API_URL = '/* @echo BASE_API_URL */';
let BASE_AUTH_URL = '/* @echo BASE_AUTH_URL */';

let MIA_BASE_URL = null; // get this url from lti launch result

let APPLICATION_ID = 2;
let LTI_ASSESMENT = 'AC4A3F13-180E-44D2-88D2-83FD88CF980E';
let LTI_CURSUS = '47E9833C-F3BB-43FB-B5CF-347769A44EEC';

$.ajaxSetup({
    converters: {
        "text json": function (response) {
            return (response == "") ? null: JSON.parse(response);
        },
    },
})

let self = {
    'request': (method, url, data = null, auth = true, isRetry = false) => {
        let headers = auth ? { 'Authorization': 'Bearer ' + Auth.getToken() } : {};
        
        if(method !== 'GET' && data && !isRetry)
        {
            data = JSON.stringify(data);
        }

        return $.ajax({
            'type': method,
            'url': BASE_API_URL + url,
            'headers': headers,
            'contentType': 'application/json',
            'data': data,
            'dataType': 'json'
        }).catch(response => {
            // Check for various token errors
            if(response.responseJSON) {
                let error = response.responseJSON.error;
                if (error === 'token_expired') {
                    // If this IS a refresh attempt, OR we already retried go back to login
                    if(isRetry) {
                        Auth.logout();

                        router.push({ name: 'login' });
                    } else {
                        self.refreshToken()
                            .then(() => {
                                return self.request(method, url, data, true, true);
                            })
                    }

                    // Nothing else here
                    return;
                }
                else if(error === 'token_invalid' || error === 'user_not_found') {
                    Auth.logout();

                    router.push({ name: 'login' });
                    return;
                }
            }

            // Throw it down the chain
            throw response;
        });
    },

    // Account

    'login': (username, password) => {
        return $.ajax({
            url: BASE_AUTH_URL + 'connect/token',
            type: 'POST',
            data: {
                'grant_type': 'password',
                'username': username,
                'password': password,
                'client_id': 'api',
            }
        }).then((data) => {
            console.log('', data);
            Auth.setToken(data.access_token, data.refesh_token);

            return data;
        })
    },

    'refreshToken': () => {
        return $.ajax({
            url: BASE_AUTH_URL + 'connect/token',
            type: 'POST',
            data: {
                'grant_type': 'refresh_token',
                'client_id': 'api',
                'refresh_token': Auth.getRefreshToken(),
            }
        }).then((data) => {
            Auth.setToken(data.access_token, data.refesh_token);

            return data;
        })
    },

    'register': (username, password, role) => {
        return self.request('POST', 'api/account/register', { 'userName': username, password, role }, false);
    },

    // Profile

    'getProfile': () => {
        return self.request('GET', 'api/profile');
    },

    'putProfile': (profile) => {
        return self.request('PUT', 'api/profile', profile);
    },

    'deleteProfile': () => {
        return self.request('DELETE', 'api/profile');
    },

    'getEducations': () => {
        return self.request('GET', 'api/profile/educations');
    },

    'postOrPutEducation': (education) => {                
        if (education.id) return self.putEducationById(education.id, education);
        return self.postEducation(education);
    },

    'postEducation': (education) => {                
        return self.request('POST', 'api/profile/educations', education);
    },

    'getEducationById': (id) => {
        return self.request('GET', 'api/profile/educations/' + encodeURIComponent(id));
    },

    'putEducationById': (id, education) => {
        return self.request('PUT', 'api/profile/educations/' + encodeURIComponent(id), education);
    },

    'deleteEducationById': (id) => {
        return self.request('DELETE', 'api/profile/educations/' + encodeURIComponent(id));
    },

    'putNotification': (notifications) => {
        return self.request('PUT', 'api/user/notification-settings', notifications);
    },

    'getNotification': () => {
        return self.request('GET', 'api/user/notification-settings');
    },

    'getApplicationStatus': (vid = APPLICATION_ID) => {
        return self.request('GET', 'api/applications/' + encodeURIComponent(vid) + '/status');
    },  

    'postApplication': (vid = APPLICATION_ID) => {
        return self.request('POST', 'api/vacancy/2/apply', vid)
    },

    // Employer

    'anonymousAcceptApplication': (token) => {
        return self.request("POST", 'api/applications/accept/' + encodeURIComponent(token));
    },

    // Lti

    'getLtiLaunchParameters': (id) => {
        return self.request("GET", 'api/lti/' + encodeURIComponent(id) + '/launch-parameters');
    },

    'getToken': (lti) => {
        return self.request("GET", 'api/lti/' + encodeURIComponent(lti) + '/launch-parameters').then((launchParameters) => {
            var url = launchParameters.action.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
            MIA_BASE_URL = url[0] + 'api/v1/';
            return $.ajax({
                'type': 'POST',
                'url': launchParameters.action,
                'data': launchParameters.fields
            }).then((result) => {
                self.getMIATokenRequest = null;
                return $(result).find('form > #token').val();
            });
        });
    },

    'getMIAToken': (lti = LTI_ASSESMENT) => {
        if (self.getMIATokenRequest) {
            console.log('using existing mia token request');
            return self.getMIATokenRequest;
        }

        self.getMIATokenRequest = self.getApplicationStatus().then((result) => {
            console.log(result);
            store.commit('setHasAccessToCourse', result.id);
            if (result.id == 2) // accepted
            {                
                lti = LTI_CURSUS;
            }
            self.getMIATokenRequest = null;
        }).catch(_ => {}).then(() => {

            console.log('requesting token on ', lti);            
            return self.getToken(lti)

                .then((token) => {
                    
                    return token;
                })
                .done(() => { self.getMIATokenRequest = null; });            
        });

        return self.getMIATokenRequest;
    },

    'getMIAURL': () => {
        return MIA_BASE_URL;
    }
}

self.MIA = MIA;

export default self;